module.exports = __webpack_public_path__ + "front-wj51c.png?703f45782a4d467a8c203140f7075cf1";